import i18n from '@/i18n'
import moment from 'moment'
import Vue from 'vue'

const navigatorLanguage = window.navigator.language.split('-')[0]
moment.locale(navigatorLanguage)

function dateFilter (input, format) {
  let date = moment(input)
  
  if (!date.isValid()) {
    console.error(`${input} is not a valid date.`)
    return input
  }
  
  if (input === 'now') {
    date = moment()
  }
  
  if (format === 'v') {
    return date.calendar(null, {
      lastDay: `[${i18n.t('DATE.YESTERDAY')}]`,
      sameDay: `[${i18n.t('DATE.TODAY')}]`,
      nextDay: `[${i18n.t('DATE.TOMORROW')}]`,
      lastWeek: 'L',
      nextWeek: 'L',
      sameElse: 'L'
    })
  }
  
  return date.format(format)
}

export default Vue.filter('date', dateFilter)
